"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var baseTransport_1 = tslib_1.__importDefault(require("../base/baseTransport"));
var MtTransport = /** @class */ (function (_super) {
    tslib_1.__extends(MtTransport, _super);
    function MtTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MtTransport.prototype.doSend = function (log) {
        var category = this.options.endpoint;
        var type = log.type, value = log.value, tags = log.tags;
        return new Promise(function (resolve, reject) {
            KNB.use('sendBabelLog', {
                category: category,
                type: type,
                value: value,
                tags: tags,
                success: function () {
                    resolve(true);
                },
                fail: function (err) {
                    reject(err);
                },
            });
        });
    };
    return MtTransport;
}(baseTransport_1.default));
exports.default = MtTransport;
//# sourceMappingURL=mt-transport.js.map